import 'aws-amplify/auth/enable-oauth-listener';

import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { Loader } from '@/components/Loader';
import { useAuth } from '@/state/auth';

const Hello: React.FC = () => {
  // Note: useAuth() is called by CheckNoAuth wrapper which handles redirect when isSignedIn becomes true
  useAuth();

  const urlParams = new URLSearchParams(window.location.search);
  const errorDescription = urlParams.get('error_description');

  // Show error if OAuth failed
  if (errorDescription) {
    return (
      <div
        data-testid="oauth-error-container"
        className="bg-layer1 flex min-h-screen items-center justify-center"
      >
        <div className="border-chariot-stroke bg-layer0 w-full max-w-md rounded-lg border p-6 shadow">
          <div className="flex items-center space-x-3">
            <ExclamationTriangleIcon
              data-testid="error-icon"
              className="size-6 text-yellow-500"
            />
            <h2
              data-testid="error-title"
              className="text-chariot-text-primary text-xl font-semibold"
            >
              Something went wrong
            </h2>
          </div>
          <p
            data-testid="error-message"
            className="text-chariot-text-secondary mt-4"
          >
            {errorDescription}
          </p>
        </div>
      </div>
    );
  }

  // OAuth callback page - show loading while authentication completes
  // OAuth redirect is handled by Hub.listen('auth', 'signInWithRedirect') in auth.tsx
  // which uses sessionStorage.oauth_redirect_url to navigate to the original URL
  return (
    <div data-testid="oauth-loading-container" className="min-h-screen">
      <Loader isLoading={true} type="spinner" className="min-h-screen" />
    </div>
  );
};

export default Hello;
